import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { NgMarkdownComponent } from '@mycicero/ng-markdown'
import { DialogModule } from 'primeng/dialog'
import { FormElementsModule } from '../form-elements/form-elements.module'
import { MarkdownDialogComponent } from './markdown-dialog/markdown-dialog.component'

@NgModule({
  declarations: [MarkdownDialogComponent],
  imports: [CommonModule, DialogModule, NgMarkdownComponent, FormElementsModule],
  exports: [MarkdownDialogComponent],
})
export class TermsAndConditionsModule {}
